var modules_8bb178ca = {"container":"_1o2cq4c","iconWrapper":"_4krzlw","icon":"_1lidqkr","bounceIn":"_owi50i","bounce-in":"_194tacl","bounceOut":"_ar9cmj","bounce-out":"_1rw9taw"};
import "../../../assets/BQlsfFVA.css";

export { modules_8bb178ca as default };
//# sourceMappingURL=ThemeSwitcher.module.less.js.map
